<template>
  <div class="d-flex justify-content-center">
    <div class="card col-lg-4">
      <div class="card-header">
        <div class="d-flex justify-content-center">
          <img id="fb-logo-client" class="" style="width: 55px; height: 55px;" src="../assets/icon/bot.png">
          <p class="ms-2 mt-3 font-roboto-regular-18">Tools</p>
        </div>
      </div>
      <div class="card-body">
        <div class="ps-4 ms-2 me-4">
          <div class="d-flex justify-content-center">
            <form @submit.prevent="submitForm">
              <div class="col-md-12 p-2">
                <input v-model="api.apiUser" class="form-control" placeholder="API User">
              </div>
              <div class="col-md-12 p-2">
                <input type="password" v-model="api.apiPass" class="form-control" placeholder="API Password">
              </div>
            </form>          
          </div>
        </div>
      </div>
      <div class="card-footer pb-4">
        <div class="d-flex col-lg-12 justify-content-end mt-3 ms-3">
          <div class="col-lg-4">
            <button class="btn btn-primary" @click="submitForm">Ingresar</button>
          </div>
        </div>    
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';

export default {
  name: 'LoginComponent',
  components: {},
  data() {
    return {
      checkbox: false,
      api: {
        apiUser: '',
        apiPass: '',
      },
    };
  },
  methods: {
    async submitForm() {
      if(this.api.apiPass!=='' && this.api.apiUser!==''){
          localStorage.setItem('user', this.api.apiUser)
          localStorage.setItem('pass', this.api.apiPass)
        }else localStorage.removeItem('user') && localStorage.removeItem('pass')

      try {
        this.$fieldbeat.authorize_as_basic(this.api.apiUser, this.api.apiPass);
        this.$fieldbeat.get('/fleets/develop/configuration').then((response)=>{

          let res = response.code === 200 ? router.push('/indexPage')  : localStorage.removeItem('user') && localStorage.removeItem('pass')
          return res;

        })
        console.log(this);
      } catch (error) {
        console.error('Error en la autorización:', error);
      }
    },
  },
};
</script>

<style>
  .form-check-label{
    font-family: Roboto-Regular;
    font-style: normal;
    font-size: 13px !important;
  }
  
  .form-check .form-check-input{
    padding-right: 0px;
    
    height: 17px;
    width: 17px;
  }

  .form-check {
    text-align: left !important;
  }

  .form-check-input[type=checkbox]{
    border: ridge !important;
  }
</style>
